import InteractiveMapContainerMobile from '../../../../components/containers/InteractiveMapContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadInteractiveMap';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'interactive-map--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: InteractiveMapContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
